import { ID } from "../core/id";

export interface Ticket {
  id: ID;
  object_id: ID; // ID заказа или задания
  object_type: TicketObjectType;
  topic_id?: number;
  user_id: ID;
  status: TicketStatus;
  created_at: number;
  updated_at: number;
  keywords: string[];
  priority: number;
}

export enum TicketStatus {
  OPEN = "open",
  CLOSED = "closed",
  IN_PROGRESS = "in_progress",
  PROBLEM = "problem",
}
export interface TicketMessage {
  id: ID;
  ticket_id: ID;
  topic_id?: number;
  user_id: ID;
  message: string;
  created_at: number;
}

export enum TicketObjectType {
  ORDER = "order",
  JOB = "job",
  EXECUTOR = "executor",
}

export const TICKET_OBJECT_TYPE_LABELS = {
  [TicketObjectType.ORDER]: "Заказ",
  [TicketObjectType.JOB]: "Задание",
  [TicketObjectType.EXECUTOR]: "Исполнитель",
};
